import { useState, useContext } from "react";
import { Card, Table, Form, Button, Row, Col } from "react-bootstrap";
import Loading from "components/Util/Loading";
import AppContext from "store/AppContext";
import request from "services/request.service";

export default function UnivisionSubCheck(props) {
  const [univisionInfo, setUnivisionInfo] = useState({});
  const [subId, setSubId] = useState("");
  const [loading, setLoading] = useState(false);
  const appContext = useContext(AppContext);

  const checkSubId = async () => {
    try {
      setLoading(true);
      const response = await request(
        `/univision/univision/univision/check?subId=${subId}`, //?
        "GET"
      );
      console.log(response.data, "response.data");
      setUnivisionInfo(response.data.data);
      appContext.notify("tr", "success", response.data.message);
    } catch (err) {
      appContext.notify("tr", "danger", "Алдаа гарлаа");
      console.log("check univision sub error", err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center mb-3">
        <Card.Title as="h4" className="mb-0">
          Univision
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col sm="12">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                checkSubId();
              }}
            >
              <Form.Row className="align-items-center">
                <Form.Group as={Col}>
                  <Form.Label>Гэрээний дугаар</Form.Label>
                  <Form.Control
                    type="number"
                    value={subId}
                    onChange={(e) => {
                      setSubId(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} sm="3" controlId="formGridPassword">
                  {loading ? (
                    <>
                      <Loading loading={loading} />
                    </>
                  ) : (
                    <>
                      <Button
                        style={{ marginTop: "20px" }}
                        variant="primary"
                        className="btn btn-sm"
                        size="md"
                        onClick={checkSubId}
                      >
                        Шалгах
                      </Button>
                    </>
                  )}
                </Form.Group>
              </Form.Row>
            </Form>
          </Col>
        </Row>
        <Table
          className="table-hover table-striped"
          style={{
            fontSize: "12px",
          }}
        >
          <thead>
            <tr>
              <th>Admin</th>
              <th>Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{univisionInfo?.adminNo}</td>
              <td>{univisionInfo?.customerType}</td>
              <td>
                {univisionInfo?.isActive == true
                  ? "Идэвхитэй"
                  : univisionInfo?.isActive == false
                  ? "Идэвхигүй"
                  : ""}
              </td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}
